<template lang="pug">
    Modal
        .form
            h2  Copy content from another market
            .form__control-group
                label Copy Content from...
                multiselect(
                    v-model="copiedLocale"
                    :options="getSortedAvailableLocales"
                    :searchable="false"
                    :selectLabel="''"
                    :allow-empty="false"
                    :deselectLabel="''"
                    :multiple="false"
                )
            p
                em Warning: this action will completely replace the current local record's published and draft content with the content from the selected market.
            button.button__submit(
                @click="submit"
            ) Copy and replace card content
</template>
<script>
import Modal from '../general/Modal';
import store from '../../store';
import Services from '../../services/Services';
import { postResource } from '../../services/Utils.js';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import VueNotifications from 'vue-notifications';
export default {
    name: 'CopyLocalRecord',
    components: {
        Modal,
        Multiselect,
    },
    data() {
        return {
            isCopying: false,
            copiedLocale: ''
        }
    },
    computed: {
        getActiveCard() {
            return store.getters.getActiveCard;
        },
        getActiveLocale(){
            return store.getters.getActiveLocale;
        },
        getSortedAvailableLocales(){
            if (this.getActiveCard && this.getActiveCard.localRecords) {
                let locales = [];

                this.getActiveCard.localRecords.forEach(locale => {
                    if(locale.locale !== this.getActiveLocale){
                        locales.push(locale.locale);
                    }
                });

                return locales.sort((a, b) => a.name - b.name).reverse();
            }
        },
        getAvailableMarkets() {
            return store.getters.getMarkets;
        },
        getMarketsByLocale() {
            if (this.getAvailableMarkets) {
                let marketsByLocale = [];

                this.getAvailableMarkets.forEach(market => {
                marketsByLocale.push(market.locale);
                });

                return marketsByLocale;
            }
        },
    },
    notifications: {
        showSuccessMsg: {
        type: VueNotifications.types.success,
        title: '',
        icon: '✅'
        },
        showErrorMsg: {
        type: VueNotifications.types.error,
        title: '',
        icon: '❗️'
        }
    },
    mounted(){
        Services.getMarkets();
    },
    methods: {
        submit(){
            const update = {
                recordId: this.getActiveCard._id,
                targetLocale: this.getActiveLocale,
                sourceLocale: this.copiedLocale
            }

            console.log(update);

            postResource('/v1/actioncards/copy', false, update)
                .then(res => {
                    console.log('success!', res);
                    this.showSuccessMsg({ message: `Content copied from ${this.copiedLocale}!` });
                    store.commit('hideModals', true);
                    Services.setActiveCard(this.getActiveCard._id, this.getActiveLocale);
                    store.commit('setActiveLocale', res.targetLocalRecord.locale)
                    store.commit('setActiveLocalRecord', res.targetLocalRecord.content);
                    return res;
                })
                .catch(error => {
                    let message = 'An error occurred. Please try again.';
                    if(error.error){
                        message = error.error;
                    }
                    this.showErrorMsg({
                    message
                    });
                });
        }
    }
}
</script>
<style lang="scss" scoped>
h2 {
    text-align: center;
}

.form {
    padding: 2rem;
}

.form__control-group.rule__control-group--select:after {
    top: 20px;
}

button {
    margin: 2rem auto 0;
}

.copy-content {
    margin-top: 20px;

    div {
        margin-top: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/modals/CopyCardLocalRecord.vue